import React from 'react';
import './Dashboard.css';
import { Menu, Container } from 'semantic-ui-react';

interface LayoutProps {
    children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children = null }: LayoutProps) => {
    return (
        <>            
            {/* Main Content */}
            <Container style={{ minHeight: '80vh', padding: '2em 0' }}>
                {children}
            </Container>      
        </>
    );
}

export default Layout;
